/**
 * Semantic status surface classes — SSOT for pills, chips, and badge fills.
 * Tokens flip in `theme-runtime` (`.dark` / `.light`); never hardcode light pastels
 * (`#dcfce7`, `#fee2e2`, mix-with-white) — those wash out or invert contrast in dark mode.
 */

export type StatusTone = 'success' | 'warn' | 'danger' | 'info' | 'neutral';

/** Soft fill + foreground (table pills, Badge solid, compact chips). */
export const STATUS_TONE_SURFACE: Readonly<Record<StatusTone, string>> = {
  success: 'bg-[var(--color-an-success-soft)] text-[var(--color-an-success)]',
  warn: 'bg-[var(--color-an-warn-soft)] text-[var(--color-an-warn)]',
  danger: 'bg-[var(--color-an-danger-soft)] text-[var(--color-an-danger)]',
  info: 'bg-[var(--color-an-info-soft)] text-[var(--color-an-info)]',
  neutral: 'bg-[var(--color-an-surface-hover)] text-[var(--color-an-text-muted)]',
};

/** Bordered chip (ops strips, run status, attention chips). */
export const STATUS_TONE_CHIP: Readonly<Record<StatusTone, string>> = {
  success:
    'border-[color-mix(in_oklab,var(--color-an-success)_35%,var(--color-an-border))] bg-[var(--color-an-success-soft)] text-[var(--color-an-success)]',
  warn:
    'border-[color-mix(in_oklab,var(--color-an-warn)_40%,var(--color-an-border))] bg-[var(--color-an-warn-soft)] text-[var(--color-an-warn)]',
  danger:
    'border-[color-mix(in_oklab,var(--color-an-danger)_35%,var(--color-an-border))] bg-[var(--color-an-danger-soft)] text-[var(--color-an-danger)]',
  info:
    'border-[color-mix(in_oklab,var(--color-an-info)_35%,var(--color-an-border))] bg-[var(--color-an-info-soft)] text-[var(--color-an-info)]',
  neutral:
    'border-[var(--color-an-border)] bg-[var(--color-an-surface-hover)] text-[var(--color-an-text-muted)]',
};

export function statusToneSurface(tone: StatusTone): string {
  return STATUS_TONE_SURFACE[tone];
}

export function statusToneChip(tone: StatusTone): string {
  return STATUS_TONE_CHIP[tone];
}
